/* Current Nostalgia — header logo: still mark by default, spin on hover/focus.
   The animated GIF is only fetched the first time someone hovers, and never for visitors who
   ask for reduced motion. */
(function () {
  if (window.__cnLogo) return;
  window.__cnLogo = true;
  function init() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    document.querySelectorAll('[data-cn-logo]').forEach(function (wrap) {
      var img = wrap.querySelector('img');
      var link = wrap.closest('a') || wrap;
      var still = wrap.getAttribute('data-cn-logo-still');
      var spin = wrap.getAttribute('data-cn-logo-spin');
      if (!img || !spin) return;
      var warmed = false;
      function on() {
        if (!warmed) { warmed = true; var pre = new Image(); pre.src = spin; }
        img.src = spin;
      }
      function off() { img.src = still; }
      link.addEventListener('mouseenter', on);
      link.addEventListener('mouseleave', off);
      link.addEventListener('focus', on);
      link.addEventListener('blur', off);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
